import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35596f79&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=35596f79&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35596f79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35596f79')) {
      api.createRecord('35596f79', component.options)
    } else {
      api.reload('35596f79', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35596f79&scoped=true", function () {
      api.rerender('35596f79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personnel/index.vue"
export default component.exports